export { default } from './RunFormTriageDot';
